import { render } from "./showLotComponent.vue?vue&type=template&id=65ff9a87"
import script from "./showLotComponent.vue?vue&type=script&lang=js"
export * from "./showLotComponent.vue?vue&type=script&lang=js"

import "./showLotComponent.vue?vue&type=style&index=0&id=65ff9a87&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__